<template>
  <div class="build-detail-page">
    <div class="page-header">
      <!-- <a-page-header
        :title="builds.estateName || ''"
        @back="() => $router.push({ path: '/app/build/buildmessage' })"
      ></a-page-header> -->
      <a-page-header :ghost="true" :title="builds.estateName || ''">
        <template slot="extra">
          <a-button
            @click="() => $router.push({ path: '/app/build/buildmessage' })"
            type="primary"
          >
            返 回
          </a-button>
        </template>
      </a-page-header>
    </div>
    <div class="tree-and-content">
      <div class="build-left-tree">
        <div class="tree" id="tree">
          <a-tree
            :treeData="treeData"
            @select="selectTree"
            :selectedKeys="selectedKey"
          >
            <template slot="title" slot-scope="{ title, key }">
              <div class="icon-title">
                <div class="title">{{ title }}</div>
                <i
                  v-if="selectedKey && selectedKey[0] === key"
                  class="iconfont icon-dian"
                />
              </div>
            </template>
          </a-tree>
        </div>
        <!-- <div class="btns">
          <a-button
            v-if="selects.type !== 'room'"
            type="primary"
            @click="() => openModal({ title: '添加楼层', types: 'floor' })"
            >添加楼层</a-button
          >
          <a-button
            v-if="selects.type === 'floor'"
            type="primary"
            @click="() => openModal({ title: '添加区域', types: 'area' })"
            >添加区域</a-button
          >
        </div> -->
      </div>
      <div class="build-right">
        <div
          class="build-content"
          id="build-content"
          v-if="selectedKey.length > 0"
        >
          <div class="title-and-btn">
            <div class="title">{{ selects.title || "" }}</div>
            <div class="btns">
              <a-button
                v-if="selects.type !== 'room'"
                type="primary"
                @click="() => openModal({ title: '添加楼层', types: 'floor' })"
                >添加楼层</a-button
              >
              <a-button
                v-if="selects.type === 'floor'"
                type="primary"
                @click="() => openModal({ title: '添加区域', types: 'room' })"
                >添加区域</a-button
              >
              <a-button
                v-if="selects.type === 'room'"
                type="primary"
                @click="openCollectorModal"
                >新建设备</a-button
              >
              <!-- <a-popconfirm
                title="确定删除吗？"
                okType=""
                okText="删除"
                @confirm="onDelete"
              > -->
              <a-button
                @click="showDeleteModal(item)"
                v-if="selects.type !== 'estate'"
                type="danger"
                >删除</a-button
              >
              <!-- </a-popconfirm> -->
            </div>
          </div>
          <div>
            <div class="top-tips" v-if="selects.type === 'estate'">
              <div class="line"></div>
              <div>建筑信息</div>
            </div>
            <div class="top-tips" v-if="selects.type === 'floor'">
              <div class="line"></div>
              <div>楼层信息</div>
            </div>
            <div class="top-tips" v-if="selects.type === 'room'">
              <div class="line"></div>
              <div>区域信息</div>
            </div>
            <a-form
              :form="form"
              layout="inline"
              class="build-form"
              :labelCol="{ span: 8 }"
              :wrapperCol="{ span: 12 }"
            >
              <a-row :gutter="16">
                <a-col :span="9">
                  <a-form-item
                    label="建筑名称"
                    v-if="selects.type === 'estate'"
                  >
                    <a-input
                      placeholder="请输入建筑名称"
                      v-decorator="[
                        'estateName',
                        {
                          rules: [
                            { required: true, message: '请输入建筑名称' },
                          ],
                        },
                      ]"
                    />
                  </a-form-item>
                  <a-form-item
                    :label="selects.type === 'room' ? '上层楼层' : '上层建筑'"
                    v-if="selects.type !== 'estate'"
                  >
                    <div class="floorname" style="color: #9ca3ab">
                      {{ parentSelects.title || "--" }}
                    </div>
                  </a-form-item>
                </a-col>
                <a-col :span="9">
                  <a-form-item label="楼层名称" v-if="selects.type === 'floor'">
                    <a-input
                      placeholder="请输入楼层名称"
                      v-decorator="[
                        'floorName',
                        {
                          rules: [
                            { required: true, message: '请输入楼层名称' },
                          ],
                        },
                      ]"
                    />
                  </a-form-item>
                  <a-form-item label="区域名称" v-if="selects.type === 'room'">
                    <a-input
                      placeholder="请输入区域名称"
                      v-decorator="[
                        'roomName',
                        {
                          rules: [
                            { required: true, message: '请输入区域名称' },
                          ],
                        },
                      ]"
                    />
                  </a-form-item>
                </a-col>
              </a-row>

              <a-row :gutter="16">
                <a-col :span="9">
                  <a-form-item label="排序号">
                    <a-input-number
                      placeholder="请输入排序号"
                      :min="0"
                      v-decorator="['sort']"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="9">
                  <a-form-item label="备注">
                    <a-input
                      placeholder="请输入备注"
                      v-decorator="['remark']"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="16" style="margin-top: 16px">
                <a-col :span="9">
                  <a-form-item :wrapperCol="{ offset: 6 }">
                    <!-- <a-button>取消</a-button> -->
                    <a-button type="primary" @click="onSubmit">提交</a-button>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form>
          </div>
          <div class="collector" v-if="selects.type === 'room'">
            <div class="top-tips">
              <div class="line"></div>
              <div>关联采集器列表</div>
            </div>
            <div class="table" id="table">
              <a-table
                rowKey="id"
                :columns="columns"
                :dataSource="dataSource"
                :pagination="false"
              >
                <template slot="operation" slot-scope="record">
                  <div class="handle">
                    <!-- <a-tag color="red" @click="onDeleteDevice(record)"
                      >删除</a-tag
                    > -->
                    <a-tooltip
                      title="删除"
                      @click="showDeleteDeviceModal(record)"
                    >
                      <div class="icon">
                        <i class="iconfont icon-shanchu1" />
                      </div>
                    </a-tooltip>
                  </div>
                </template>
              </a-table>
            </div>
          </div>
        </div>
        <div class="empty" v-if="selectedKey.length === 0">
          <a-empty>
            <template slot="image">
              <img src="../../assets/noempty/notable.png" />
            </template>
            <!-- <template slot="description"> 请先选择建筑、楼层、区域 </template> -->
          </a-empty>
        </div>
      </div>
    </div>
    <a-modal
      class="create-floor-modal"
      :title="modalConfig.title"
      :visible="createFloorVisible"
      :maskClosable="false"
      @ok="onSaveFloorArea"
      @cancel="handleClose"
    >
      <a-form
        :form="createFloorForm"
        :labelCol="{ span: 6 }"
        :wrapperCol="{ span: 12 }"
      >
        <a-form-item label="上层楼层">
          <div class="floorname" style="color: #9ca3ab">
            {{ selects.parentName || "--" }}
          </div>
        </a-form-item>
        <a-form-item label="楼层名称" v-if="modalConfig.types === 'floor'">
          <a-input
            placeholder="请输入楼层名称"
            v-decorator="[
              'floorName',
              { rules: [{ required: true, message: '请输入楼层名称' }] },
            ]"
          />
        </a-form-item>
        <a-form-item label="区域名称" v-if="modalConfig.types === 'room'">
          <a-input
            placeholder="请输入区域名称"
            v-decorator="[
              'roomName',
              { rules: [{ required: true, message: '请输入区域名称' }] },
            ]"
          />
        </a-form-item>
        <a-form-item label="排序号">
          <a-input-number placeholder="请输入排序号" v-decorator="['sort']" />
        </a-form-item>
        <a-form-item label="备注">
          <a-input placeholder="请输入备注" v-decorator="['remark']" />
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal
      class="add-collecyot-modal"
      width="1000px"
      title="关联采集器"
      :visible="collectorVisible"
      :maskClosable="false"
      @ok="onSaveDevice"
      @cancel="handleCloseCollector"
    >
      <a-form
        :form="createCollectorForm"
        :labelCol="{ span: 4 }"
        :wrapperCol="{ span: 18 }"
      >
        <a-form-item label="上级区域">
          <div class="name" style="color: #9ca3ab">
            {{ selects.parentName || "" }}
          </div>
        </a-form-item>
        <a-form-item label="关联采集器">
          <a-select
            style="width: 690px"
            v-decorator="[
              'parentId',
              { rules: [{ required: true, message: '请选择采集器' }] },
            ]"
            @select="selectColl"
          >
            <a-select-option
              v-for="(item, index) in collectorList"
              :value="item.id"
              :key="index"
              >{{ item.deviceName }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item label="关联设备全选/反选" v-if="devicelist.length > 0">
          <a-checkbox
            :indeterminate="deviceIds.length < devicelist.length"
            @change="changeAll"
            :checked="
              devicelist.length > 0 && deviceIds.length === devicelist.length
            "
          >
            全选/反选
          </a-checkbox>
        </a-form-item>
        <a-form-item label="关联设备" class="device">
          <a-checkbox-group
            v-decorator="[
              'ids',
              { rules: [{ required: true, message: '请选择关联设备' }] },
            ]"
            @change="changeCheck"
          >
            <a-row :gutter="[16, 16]">
              <a-col :span="8" v-for="(item, index) in devicelist" :key="index">
                <a-checkbox :value="item.id">
                  {{ item.deviceName }}
                </a-checkbox>
              </a-col>
            </a-row>
            <!-- <div
              class="device-item"
              v-for="(item, index) in devicelist"
              :key="index"
            >
              <div class="title">{{ item.title }}</div>
              <a-row :gutter="[16, 16]">
                <a-col
                  :span="6"
                  v-for="(child, indexs) in item.list"
                  :key="indexs"
                >
                  <a-checkbox :value="child.id">{{
                    child.deviceName
                  }}</a-checkbox>
                </a-col>
              </a-row>
            </div> -->
          </a-checkbox-group>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import {
  roomDeviceList,
  estateTree,
  estateUpdate,
  floorAdd,
  floorDelete,
  floorUpdate,
  roomAdd,
  roomDelete,
  roomDeviceDelete,
  roomDevicePage,
  roomDeviceUnboundList,
  roomUpdate,
  roomDeviceUpdate,
  collDeviceList,
  bindDeviceList,
  deviceClientList,
} from "./service";
import TreeModel from "tree-model";
import eventStatusMixin from "../../mixins/eventStatus";
import scrollbarInit from "../../utils/perfectScrollBar";

const columns = [
  {
    title: "序号",
    dataIndex: "index",
    customRender: (text) => {
      return text || "--";
    },
  },
  {
    title: "关联采集器",
    dataIndex: "deviceName",
    customRender: (text) => {
      return text || "--";
    },
  },
  {
    title: "操作",
    dataIndex: "",
    width: 300,
    scopedSlots: { customRender: "operation" },
  },
];
export default {
  mixins: [eventStatusMixin],
  data() {
    return {
      form: this.$form.createForm(this),
      createFloorForm: this.$form.createForm(this),
      createCollectorForm: this.$form.createForm(this),
      builds: {},
      treeData: [],
      selects: {},
      selectedKey: [],
      parentSelects: {},
      columns,
      dataSource: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },

      createFloorVisible: false,
      modalConfig: {},
      modalRecord: {},

      collectorVisible: false,
      devicelist: [],
      collectorList: [],
      checkAll: false,
      indStu: false,
      deviceIds: [],

      treeRoot: null,
    };
  },
  created() {
    let builds = JSON.parse(this.$route.query.builds);
    this.builds = builds;
    this.getEstateTreeData();
  },
  watch: {
    $route() {
      this.$nextTick(() => {
        this.createRightScroll();
      });
    },
  },
  mounted() {
    this.createTreeScroll();
    // this.createRightScroll();
  },
  methods: {
    createRightScroll() {
      const scrollBar = scrollbarInit("#table");
      const dom = document.querySelector("#table");
      dom.scrollTop = 0;
      scrollBar.update();
    },
    createTreeScroll() {
      const scrollBar = scrollbarInit("#tree");
      const dom = document.querySelector("#tree");
      dom.scrollTop = 0;
      scrollBar.update();
    },
    openModal(modalConfig = {}) {
      if (this.selectedKey.length > 0) {
        (this.createFloorVisible = true), (this.modalConfig = modalConfig);
      } else this.$message.info("请选择楼层或区域");
    },
    handleClose() {
      (this.createFloorVisible = false), this.createFloorForm.resetFields();
      this.modalConfig = {};
      this.modalRecord = {};
    },
    handleCloseCollector() {
      this.createCollectorForm.resetFields();
      this.collectorVisible = false;
      this.devicelist = [];
      this.collectorList = [];
      this.checkAll = false;
      this.indStu = false;
      this.deviceIds = [];
    },
    async getEstateTreeData() {
      try {
        const params = {
          id: this.builds.id,
        };

        const res = await estateTree.request(params, {
          showBizRemind: true,
        });

        if (res.bizCode === 1) {
          const data = [];
          data.push({ ...res.data });
          const list = this.genTree(data);

          this.treeData = list;
          const tree = new TreeModel();
          if (list.length > 0) {
            const treeRoot = tree.parse(list[0]);
            this.treeRoot = treeRoot;
          }
          console.log("1", list);
        }
      } catch (err) {
        console.error(err);
      }
    },

    genTree(tree) {
      const trvTree = (list, name) => {
        const tmpArr = [];
        list.map((item) => {
          let tmp = {
            ...item,
            key: `${item.id}-${item.type}`,
            scopedSlots: {
              title: "title",
            },
          };
          if (Array.isArray(item.children) && item.children.length > 0) {
            if (item.type === "estate") {
              tmp.children = trvTree(item.children, item.estateName);
            } else if (item.type === "floor") {
              tmp.children = trvTree(item.children, item.floorName);
            }
            //console.log('2',tmpArr)
          }
          if (item.type === "estate") {
            tmp.title = item.estateName;
          } else if (item.type === "floor") {
            tmp.title = item.floorName;
            tmp.parentName = name;
          } else {
            tmp.title = item.roomName;
            tmp.parentName = name;
          }
          tmpArr.push({ ...tmp });
        });
        return tmpArr;
      };

      return trvTree(tree);
    },
    selectTree(key) {
      console.log(key);
      this.selectedKey = key;
      if (key.length > 0) {
        let nodes = this.treeRoot.first(function (node) {
          return node.model.key === key[0];
        });
        console.log("nodes", nodes);
        this.selects = nodes.model;
        this.$nextTick(() => {
          this.form.setFieldsValue({
            estateName: nodes.model.estateName,
            sort: nodes.model.sort,
            remark: nodes.model.remark,
            floorName: nodes.model.floorName,
            roomName: nodes.model.roomName,
          });
        });
        if (nodes.model.type !== "estate") {
          this.parentSelects = nodes.parent.model;
        }
        if (nodes.model.type === "room") {
          this.dataSource = [];
          this.getRoomDeviceData();
          this.$nextTick(() => {
            this.createRightScroll();
          });
        }
      }
    },
    async onSaveFloorArea() {
      if (this.hasEventState("onSaveFloorArea")) return;
      try {
        this.addEventState("onSaveFloorArea");
        const formVals = await this.createFloorForm.validateFields();
        const params = {
          ...formVals,
        };

        if (this.modalConfig.types === "floor") {
          if (this.selects.type === "estate") {
            params.estateId = this.selects.id;
          } else {
            params.estateId = this.selects.estateId;
            params.floorParentId = this.selects.floorParentId;
            params.floorRootParentId = this.selects.floorRootParentId;
          }
        } else if (this.modalConfig.types === "room") {
          params.estateId = this.selects.estateId;
          params.floorId = this.selects.id;
        }

        const apiMethod =
          this.modalConfig.types === "floor" ? floorAdd : roomAdd;

        const res = await apiMethod.request(params, {
          showBizRemind: true,
          lock: true,
        });

        if (res.bizCode === 1) {
          this.$message.success("添加成功");
          this.handleClose();
          this.getEstateTreeData();
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.removeEventState("onSaveFloorArea");
      }
    },
    async onSubmit() {
      if (this.hasEventState("onSubmit")) return;
      try {
        this.addEventState("onSubmit");
        const formVals = await this.form.validateFields();

        const params = {
          ...formVals,
          id: this.selects.id,
        };

        const apiUrl = {
          estate: estateUpdate,
          floor: floorUpdate,
          room: roomUpdate,
        };
        const apiMethod = apiUrl[this.selects.type];

        const res = await apiMethod.request(params, {
          showBizRemind: true,
          lock: true,
        });

        if (res.bizCode === 1) {
          this.$message.success("修改成功");
          this.getEstateTreeData();
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.removeEventState("onSubmit");
      }
    },
    async onDelete() {
      if (this.hasEventState("onDelete")) return;
      try {
        this.addEventState("onDelete");
        const params = {
          id: this.selects.id,
        };

        const apiMethod =
          this.selects.type === "floor" ? floorDelete : roomDelete;

        const res = await apiMethod.request(params, {
          showBizRemind: true,
          lock: true,
        });

        if (res.bizCode === 1) {
          this.$message.success("删除成功");
          this.getEstateTreeData();
          this.selects = {};
          this.parentSelects = {};
          this.selectedKey = [];
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.removeEventState("onDelete");
      }
    },
    async getRoomDeviceData() {
      try {
        const params = {
          roomId: this.selects.id,
          isPage: 0,
        };

        const res = await roomDevicePage.request(params, {
          showBizRemind: true,
        });

        if (res.bizCode === 1) {
          this.dataSource = res.data.items.map((item, index) => {
            return {
              ...item,
              index: index + 1,
            };
          });
        }
      } catch (err) {
        console.error(err);
      }
    },
    async onDeleteDevice(record) {
      if (this.hasEventState("onDeleteDevice")) return;
      try {
        this.addEventState("onDeleteDevice");
        const params = {
          id: record.id,
          deviceId: record.deviceId,
        };
        const res = await roomDeviceDelete.request(params, {
          showBizRemind: true,
          lock: true,
        });

        if (res.bizCode === 1) {
          this.$message.success("移除成功");
          this.getRoomDeviceData();
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.removeEventState("onDeleteDevice");
      }
    },
    showDeleteModal(item) {
      let that = this;
      this.$confirm({
        class: "delete-confirm-modal",
        title: "您确定需要删除这条内容吗？",
        content: "内容确认删除后不可恢复！",
        okText: "删除",
        okType: "primary",
        centered: true,
        width: 320,
        icon: () => (
          <a-icon type="info-circle" theme="twoTone" two-tone-color="#0F9F64" />
        ),
        onOk() {
          that.onDelete(item);
        },
        onCancel() {
          console.log("cancel");
        },
      });
    },
    showDeleteDeviceModal(item) {
      let that = this;
      this.$confirm({
        class: "delete-confirm-modal",
        title: "您确定需要删除这条内容吗？",
        content: "内容确认删除后不可恢复！",
        okText: "删除",
        okType: "primary",
        centered: true,
        width: 320,
        icon: () => (
          <a-icon type="info-circle" theme="twoTone" two-tone-color="#0F9F64" />
        ),
        onOk() {
          that.onDeleteDevice(item);
        },
        onCancel() {
          console.log("cancel");
        },
      });
    },
    openCollectorModal() {
      this.collectorVisible = true;
      //this.getDeviceData();
      //this.getDeviceBoundData();
      this.getCollDevice("collector");
    },
    async getDeviceData() {
      try {
        const params = {
          estateId: this.selects.estateId,
          floorId: this.selects.floorParentId,
          roomId: this.selects.id,
        };

        const res = await roomDeviceList.request(params, {
          showBizRemind: true,
        });

        if (res.bizCode === 1) {
          const types = {
            ELECTRIC: "电表",
            WATER: "水表",
            COLD_WATER: "冷水表",
            HOT_WATER: "热水表",
            GAS: "燃气表",
            OTHER: "其他",
          };
          let list = [];
          res.data.map((item) => {
            list.push({
              ...item,
              title: types[item.productType] || "其他",
            });
          });
          this.devicelist = list;
        }
      } catch (err) {
        console.error(err);
      }
    },
    async getDeviceBoundData() {
      try {
        const params = {
          roomId: this.selects.id,
        };

        const res = await roomDeviceUnboundList.request(params, {
          showBizRemind: true,
        });

        if (res.bizCode === 1) {
          console.log(res);
        }
      } catch (err) {
        console.error(err);
      }
    },
    async onSaveDevice() {
      if (this.hasEventState("onSaveDevice"));
      try {
        this.addEventState("onSaveDevice");
        const formVals = await this.createCollectorForm.validateFields();
        const params = {
          estateId: this.selects.estateId,
          floorId: this.selects.floorId,
          roomId: this.selects.id,
          deviceIds: formVals.ids,
        };

        const res = await roomDeviceUpdate.request(params, {
          showBizRemind: true,
          lock: true,
        });

        if (res.bizCode === 1) {
          this.$message.success("关联成功");
          this.handleCloseCollector();
          this.getRoomDeviceData();
          this.createRightScroll();
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.removeEventState("onSaveDevice");
      }
    },
    selectColl(val) {
      this.devicelist = [];
      // this.getCollDevice("device", val);
      this.getBindDevice(val);
    },
    async getBindDevice(val) {
      try {
        const params = {
          masterDeviceId: val,
          roomId: this.selects.id,
        };

        const res = await bindDeviceList.request(params, {
          showBizRemind: true,
        });

        if (res.bizCode === 1) {
          const ids = [];
          this.devicelist = res.data;
          res.data.map((item) => {
            ids.push(item.deviceId);
          });
          this.$nextTick(() => {
            this.createCollectorForm.setFieldsValue({
              ids,
            });
          });
        }
      } catch (err) {
        console.error(err);
      }
    },
    async getCollDevice(type, id) {
      try {
        const params = {
          isPage: 0,
        };
        if (type === "collector") {
          params.deviceType = "BLACK_BOX";
        } else if (type === "device") {
          params.deviceType = "CLIENT";
          params.parentId = id;
        }

        const apiMethod =
          type === "collector" ? collDeviceList : deviceClientList;

        const res = await apiMethod.request(params, {
          showBizRemind: true,
        });

        if (res.bizCode === 1) {
          if (type === "collector") {
            this.collectorList = res.data.items;
          } else if (type === "device") {
            this.devicelist = res.data.items;
          }
        }
        console.log(this.devicelist);
      } catch (err) {
        console.error(err);
      }
    },
    changeAll(e) {
      const ids = [];
      if (e.target.checked) {
        this.devicelist.map((item) => {
          ids.push(item.id);
        });
      }
      this.createCollectorForm.setFieldsValue({
        ids: ids,
      });
      this.deviceIds = ids;
      //console.log('e',e)
      //this.checkAll = e.target.checked;
    },
    changeCheck(val) {
      let ids = val;
      this.deviceIds = ids;
      //console.log(val)
      // if (ids.length > 0 && ids.length < this.devicelist.length) {
      //   this.indStu = true;
      //   this.checkAll = false;
      // } else if (ids.length > 0 && ids.length === this.devicelist.length) {
      //   this.indStu = false;
      //   this.checkAll = true;
      // } else {
      //   this.indStu = false;
      //   this.checkAll = false;
      // }
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../utils/convertPxToDesighViewport/convertPxToDesighViewport.less";
//.convertPxToDesighVH(20)[] .convertPxToDesighVW(20)[]
.build-detail-page {
  width: 100%;
  height: calc(100% - .convertPxToDesighVH(80) []);
  overflow: hidden;
  .page-header {
    background: #192430;
    height: .convertPxToDesighVH(80) [];
    border: .convertPxToDesighVH(2) [] solid #293646;
    border-radius: .convertPxToDesighVH(10) [];
    margin-bottom: .convertPxToDesighVH(24) [];
    > .ant-page-header {
      background: transparent;
      height: .convertPxToDesighVH(80) [];
      padding: 0 .convertPxToDesighVW(24) [] !important;
      border-radius: .convertPxToDesighVH(10) [];
    }
  }
  > .tree-and-content {
    width: 100%;
    height: calc(100vh - .convertPxToDesighVH(225) []);
    display: flex;
    > .build-left-tree {
      width: .convertPxToDesighVW(256) [];
      height: 100%;
      background: #192430;
      border: .convertPxToDesighVH(2) [] solid #293646;
      border-radius: .convertPxToDesighVH(10) [];
      > .tree {
        padding: .convertPxToDesighVH(20) [];
        width: 100%;
        height: 100%;
        position: relative;
      }
    }
    > .build-right {
      margin-left: .convertPxToDesighVW(20) [];
      background: #192430;
      border: .convertPxToDesighVH(2) [] solid #293646;
      border-radius: .convertPxToDesighVH(10) [];
      width: calc(100% - .convertPxToDesighVW(256) []);
      height: 100%;
      > .build-content {
        width: 100%;
        height: 100%;
        position: relative;
        padding: 0px .convertPxToDesighVW(20) [];
        > .title-and-btn {
          padding: .convertPxToDesighVH(20) [] 0px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px solid #57615c;
          > .title {
            font-size: .convertPxToDesighVH(24) [];
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: .convertPxToDesighVH(31) [];
            color: #e2f2ff;
          }
          > .btns {
            > .ant-btn {
              margin-left: .convertPxToDesighVW(20) [];
            }
          }
        }
        > div {
          > .top-tips {
            width: 100%;
            height: .convertPxToDesighVH(64) [];
            display: flex;
            align-items: center;
            .line {
              width: .convertPxToDesighVW(4) [];
              height: .convertPxToDesighVH(16) [];
              background: #0f9f64;
              border-radius: .convertPxToDesighVH(4) [];
              margin-right: .convertPxToDesighVW(8) [];
            }
            > div {
              font-size: .convertPxToDesighVH(16) [];
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: .convertPxToDesighVH(21) [];
              color: #e2f2ff;
            }
          }
          .ant-form {
            // background: #091121;
            // border-radius: 20px;
            padding-left: .convertPxToDesighVW(24) [];
          }
        }
        > .collector {
          width: 100%;
          height: calc(100% - .convertPxToDesighVH(300) []);
          > .top-tips {
            width: 100%;
            height: .convertPxToDesighVH(64) [];
            display: flex;
            align-items: center;
            .line {
              width: .convertPxToDesighVW(4) [];
              height: .convertPxToDesighVH(16) [];
              background: #0f9f64;
              border-radius: .convertPxToDesighVH(4) [];
              margin-right: .convertPxToDesighVW(8) [];
            }
            > div {
              font-size: .convertPxToDesighVH(16) [];
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: .convertPxToDesighVH(21) [];
              color: #e2f2ff;
            }
          }
          > .table {
            //position: relative;
            // overflow: auto;
            height: calc(100% - .convertPxToDesighVH(100) []);
            .handle {
              width: .convertPxToDesighVW(100) [];
              display: flex;
              align-items: center;
              .icon {
                width: .convertPxToDesighVW(40) [];
                height: .convertPxToDesighVH(40) [];
                background: #091121;
                border-radius: .convertPxToDesighVH(15) [];
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: .convertPxToDesighVW(24) [];
              }
              .ant-tag {
                display: flex;
                align-items: center;
                justify-content: center;
                height: .convertPxToDesighVH(32) [];
                border-radius: .convertPxToDesighVH(5) [];
                font-size: .convertPxToDesighVH(14) [];
                font-family: Microsoft YaHei;
                font-weight: 400;
              }
            }
          }
        }
      }
      > .empty {
        width: 100%;
        height: 100%;
        > .ant-empty {
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          > .ant-empty-image {
            > img {
              width: .convertPxToDesighVW(309) [];
              height: .convertPxToDesighVH(166) [];
            }
          }
          > .ant-empty-description {
            font-size: .convertPxToDesighVH(20) [];
            font-weight: bold;
          }
        }
      }
    }
  }
}

#table {
  height: calc(100% - .convertPxToDesighVH(100) []);
  position: relative;
  overflow: hidden;
}
</style>
